import downloadboxVue from './index.vue';    
// 定义插件对象
const Download = {};
// vue的install方法，用于定义vue插件
Download.install = function (Vue, options) {
  const DownloadBoxInstance = Vue.extend(downloadboxVue);
  let currentDownload;
  const initInstances = () => {
    // 实例化vue实例
    currentDownload = new DownloadBoxInstance();
    let msgBoxEl = currentDownload.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$download = {
    // showDownloadBox (options) {
    //   initInstances();
    //   currentDownload.visible = true;
    // }
    showDownloadBox (options) {
      initInstances();
      Object.assign(currentDownload, options);
      currentDownload.visible = true;
    }
  };
};
export default Download;


// WEBPACK FOOTER //
// ./src/components/common/download/index.js